
export function checkFacet() {
    $('#facetForm :checkbox, #ended').on('change', function() {
        filterModels();
    });
}

export function submitSearchForm() {
    $('body').on('submit', '#searchForm', function(e){
        e.preventDefault();
        var search = $('#search').val();
        filterModels();
        $('#search').val(search);
        $('#searchButton').attr('disabled', false);
    });
}

export function closeFacet() {
    $('body').on('click', '.facet-selected .close', function(){
        $(this).parent().remove();
        var facet = $(this).parent().attr('id');
        $('input#'+facet).prop("checked", false);
        filterModels();
    });
}

export function clear() {
    $('#clearButton').on('click', function(e) {
        e.preventDefault();
        $("input:checked").prop("checked", false);
        $(".facet-selected").remove();
        $("#search").val("");
        filterModels();
    });
}

export function sort() {
    $('#sorting').on('change', function() {
        filterModels();
    });
}

function filterModels(page) { // pas d'export, est uniquement appelée par les autres fonctions
    var page = page ? page : 1;
    var ended = $("input[id='ended']").is(":checked");
    ended = ended ? 1 : 0;
    var brands = [];
    var orientations = [];
    var number_of_strings = [];
    var configurations = [];
    var body_shapes = [];
    var body_materials = [];
    var colors = [];
    var fingerboards = [];
    var prices = [];
    var search = $("input[id='search']").val();
    var order = $("#sorting option:selected").val();
    $("input[name='brand']:checked").each(function(){ brands.push($(this).val()); });
    $("input[name='orientation']:checked").each(function(){ orientations.push($(this).val()); });
    $("input[name='number_of_string']:checked").each(function(){ number_of_strings.push($(this).val()); });
    $("input[name='configuration']:checked").each(function(){ configurations.push($(this).val()); });
    $("input[name='body_shape']:checked").each(function(){ body_shapes.push($(this).val()); });
    $("input[name='body_material']:checked").each(function(){ body_materials.push($(this).val()); });
    $("input[name='color']:checked").each(function(){ colors.push($(this).val()); });
    $("input[name='fingerboard']:checked").each(function(){ fingerboards.push($(this).val()); });
    $("input[name='price']:checked").each(function(){ prices.push($(this).val()); });
    var data = {page: page, ended: ended, search: search, brands: brands, orientations: orientations, number_of_strings: number_of_strings, configurations: configurations, body_shapes: body_shapes, body_materials: body_materials, colors: colors, fingerboards: fingerboards, prices: prices, order: order};
    console.log(data);
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $.ajax({
        method: $(this).attr('method'),
        url: $(this).attr('action'),
        data: data,
        beforeSend:function(){
            $("#models").html('<div class="loader"><div class="loader-spinner"></div></div>');
        }
    }).done(function(result) {
        $("#models").html(result);

        // show / hide selected facets
        var selectedFacetsWrapper = $('.selected-facets-wrapper');
        var selectedFacets = $('.form-check-input:checked');
        $('.facet-selected').remove();
        $.each(selectedFacets, function(index, value) {
            var id = $(this).attr('id');
            var value = $(this).val().toLowerCase().replace(' ','-');
            var displayValue = $(this).next().text();
            if (id !== 'ended') {
                selectedFacetsWrapper.append('<span id="' + id + '" class="facet-selected badge badge-primary mr-1 mb-1">' + displayValue + '<button class="close" data-facet="' + value + '">x</button></span>');
            }
        });

        // update total count
        var count = $('#total_count').data('value');
        $('#counts-value').text(count);

        // select right color picture
        if (typeof colors[0] !== "undefined") {
            $.each($('.carousel-inner'), function(index, value) {
                $(this).children('.carousel-item[data-color="'+colors[0]+'"]').first().addClass('active').siblings().removeClass('active');
            });
        }

        // update page URL
        updatePageUrl(data);

    }).fail(function(result) {
        // console.log('fail', result);
        // $.each(data.responseJSON, function (key, value) {
        //     console.log(value);
        // });
    });
}

export function updatePageUrl(data) {
    var parameters = "";
    if (data) {
        parameters = "?";
        if (data.brands.length > 0) { parameters = addUrlParameter(parameters, 'brand', data.brands)}
        if (data.orientations.length > 0) { parameters = addUrlParameter(parameters, 'orientation', data.orientations)}
        if (data.number_of_strings.length > 0) { parameters = addUrlParameter(parameters, 'number_of_string', data.number_of_strings)}
        if (data.configurations.length > 0) { parameters = addUrlParameter(parameters, 'configuration', data.configurations)}
        if (data.body_shapes.length > 0) { parameters = addUrlParameter(parameters, 'body_shape', data.body_shapes)}
        if (data.body_materials.length > 0) { parameters = addUrlParameter(parameters, 'body_material', data.body_materials)}
        if (data.colors.length > 0) { parameters = addUrlParameter(parameters, 'color', data.colors)}
        if (data.fingerboards.length > 0) { parameters = addUrlParameter(parameters, 'fingerboard', data.fingerboards)}
        if (data.prices.length > 0) { parameters = addUrlParameter(parameters, 'price', data.prices)}
        if (data.search.length > 0) { parameters = addUrlParameter(parameters, 'search', data.search)}
    }
    window.history.pushState("", "", window.location.pathname + parameters);
}

export function addUrlParameter(parameters, label, value) {
    parameters = parameters + label + "=";
    if (label === "search") { value = value.split(" ")}
    if (value) {
        value.forEach(function(brand, index) {
            parameters = parameters + brand;
            if (index !== value.length - 1){
                parameters = parameters + "+";
            }
        });
    }
    parameters = parameters + "&";

    return parameters;
}

export function pagination() {
    $('body').on('click', '.pagination a', function(e){
        e.preventDefault();
        var url = $(this).attr('href');
        var page = url.split('page=')[1];
        window.history.pushState("", "", url);
        filterModels(page);
        // $('html, body').animate({scrollTop:0}, 'fast');
    });
}

export function dropdown() {
    $('.dropdown-toggle').on('click', function() {
        if($(this).hasClass('reverse')) {
            $('.form-check-more').addClass('d-none');
            $(this).removeClass('reverse');
        } else {
            $('.form-check-more').removeClass('d-none');
            $(this).addClass('reverse');
        }
    });
}